import pimg1 from "./Images/Illustration/blog-1.a096363c44cf6e780297.jpg";
import pimg2 from "./Images/Illustration/blog-2.5aa50c12be3769556bd8.jpg";
import pimg3 from "./Images/Illustration/blog-3.6670c83bfc88b4968243.jpg";
import foot1 from "./Images/Illustration/download (2).jpg";
import foot2 from "./Images/Illustration/foot2.jpg";
import foot3 from "./Images/Illustration/foot3.jpg";

const Pages = () => {
    return (
        <section class='container-fluid'>
            <div class='row'>
                <div class='col-12 back2 text-white align'>
                    <h3>Pages</h3>

                    <div className="d-flex justify-content-center pt-3"> <nav aria-label="breadcrumb ">
                        <ol class="breadcrumb ">
                            <li class="breadcrumb-item"><a href="Home">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="Pages">Pages</li>
                        </ol>
                    </nav></div>

                </div>
                <div className="row">
                    <div class='col-12 col-md-8 py-5 '>
                        <div class="card shadow">
                            <img src={pimg1} class="card-img-top p-3" alt="Image Not Found" />
                            <div class="card-body">
                                <h5 class="card-title">If Your Car's Bettery Down.</h5>
                                <p class="card-text">Fusce quis nulla volutpat, rhoncus ligula ut, pulvinar nisi. In dapibus urna sit amet accumsan tristique. Donec odio ligula, luctus venenatis varius id, tincidunt ac ipsum. Cras commodo, velit nec aliquam dictum, tortor velit dictum ipsum, sed ornare nunc leo nec ipsum. Vestibulum sagittis</p>
                                <a href="#" class="btn">Read More</a>
                            </div>
                        </div>
                        <div class="card shadow">
                            <img src={pimg2} class="card-img-top p-3" alt="Image Not Found" />
                            <div class="card-body">
                                <h5 class="card-title">The Best Ways To Pay Drivers</h5>
                                <p class="card-text">Fusce quis nulla volutpat, rhoncus ligula ut, pulvinar nisi. In dapibus urna sit amet accumsan tristique. Donec odio ligula, luctus venenatis varius id, tincidunt ac ipsum. Cras commodo, velit nec aliquam dictum, tortor velit dictum ipsum, sed ornare nunc leo nec ipsum. Vestibulum sagittis</p>
                                <a href="#" class="btn">Read More</a>
                            </div>
                        </div>
                        <div class="card shadow">
                            <img src={pimg3} class="card-img-top p-3" alt="Image Not Found" />
                            <div class="card-body">
                                <h5 class="card-title">How Often Is A Taxi Used?</h5>
                                <p class="card-text">Fusce quis nulla volutpat, rhoncus ligula ut, pulvinar nisi. In dapibus urna sit amet accumsan tristique. Donec odio ligula, luctus venenatis varius id, tincidunt ac ipsum. Cras commodo, velit nec aliquam dictum, tortor velit dictum ipsum, sed ornare nunc leo nec ipsum. Vestibulum sagittis</p>
                                <a href="#" class="btn">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div class='col-12 col-md-4 py-5'>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Keywords..." aria-label="Recipient's username" aria-describedby="basic-addon2" />
                            <span class="input-group-text bg-dark text-white" id="basic-addon2"><i class="fa-solid fa-magnifying-glass"></i></span>
                        </div>
                        <div className="py-5">
                            <h3>By Category</h3>
                            <ul className="bg-secondary-subtle text-center p-3">
                                <li className="bg-white m-1">Headlamps (2376)</li>
                                <li className="bg-white m-1">disk break (237)</li>
                                <li className="bg-white m-1">Turbo Oil (23)</li>
                                <li className="bg-white m-1">Tyre & metal wheel (258)</li>
                                <li className="bg-white m-1">Battery (67)</li>
                                <li className="bg-white m-1">Suspension (123)</li>
                                <li className="bg-white m-1">Shock Absorber  (23)</li>
                            </ul>
                        </div>
                        <div className="py-5">
                            <h3>By Tags</h3>
                            <ul className="bg-secondary-subtle text-center p-3">
                                <li className="bg-white m-1">Apartment</li>
                                <li className="bg-white m-1">Garage</li>
                                <li className="bg-white m-1">Condo</li>
                                <li className="bg-white m-1">Villa</li>
                                <li className="bg-white m-1">Bunglow</li>
                                <li className="bg-white m-1">Electrical</li>
                                <li className="bg-white m-1">Finance</li>
                            </ul>
                        </div>
                        <div className="py-5">
                            <h3>Recent Post</h3>
                            <ul className="bg-secondary-subtle text-center p-2">
                                <li className="bg-white m-2"><div class='row'>
                                    <div class='col-3'><img src={foot1} /></div>
                                    <div class='col-9'><p>Revealed: How to set goals for you and your team</p>
                                    </div>
                                </div></li>
                                <li className="bg-white m-2"><div class='row'>
                                    <div class='col-3'><img src={foot2} /></div>
                                    <div class='col-9'><p>Revealed: How to set goals for you and your team</p>
                                    </div>
                                </div></li>
                                <li className="bg-white m-2"><div class='row'>
                                    <div class='col-3'><img src={foot3} /></div>
                                    <div class='col-9'><p>apartment in the sky love three boys of his own.</p>
                                    </div>
                                </div></li>

                            </ul>
                        </div>
                        <div className="py-5">
                            <h3>Archive</h3>
                            <ul className="bg-secondary-subtle text-center p-3">
                                <li className="bg-white m-1">August 2018</li>
                                <li className="bg-white m-1">July 2018</li>
                                <li className="bg-white m-1">June</li>
                                <li className="bg-white m-1">May</li>
                                <li className="bg-white m-1">April</li>
                                
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
};

export default Pages;
